import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CreditCard, ExternalLink, Sparkles, ArrowRight } from "lucide-react";

export const PaymentTab = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      {/* Connect Stripe CTA */}
      <div className="p-4 rounded-xl bg-gradient-to-br from-violet-500/15 to-primary/10 border border-border/50 space-y-3">
        <div className="flex items-center gap-2">
          <CreditCard className="h-5 w-5 text-violet-400" />
          <span className="text-sm font-semibold">Paiements en ligne</span>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">
          Connectez Stripe pour accepter les paiements, suivre vos revenus et synchroniser votre catalogue produits.
        </p>
        <Button
          variant="hero"
          className="w-full gap-2 h-10"
          onClick={() => navigate("/paiement")}
        >
          <Sparkles className="h-4 w-4" />
          Gérer mes paiements
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>

      {/* Quick stats placeholder */}
      <div className="grid grid-cols-2 gap-2">
        {[
          { label: "Solde Stripe", value: "—", sub: "Non connecté" },
          { label: "Transactions", value: "—", sub: "Ce mois" },
        ].map((item, i) => (
          <div key={i} className="p-3 rounded-xl bg-secondary/30 border border-border/50">
            <p className="text-[10px] text-muted-foreground uppercase tracking-wider">{item.label}</p>
            <p className="text-lg font-bold mt-1">{item.value}</p>
            <p className="text-[10px] text-muted-foreground">{item.sub}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
